import { Pipe, PipeTransform } from '@angular/core';
import { OrderItemDTO } from 'ticket-sdk';

@Pipe({
  name: 'ticketInfoFromOrderItem'
})
export class TicketInfoFromOrderItemPipe implements PipeTransform {

  transform(orderItem: OrderItemDTO, includePrice: boolean = true): string {
    let ticketInfo: string = orderItem.vehicleType?.description;

    if (includePrice) {
      ticketInfo += `, ${orderItem.price} kr`;
    }

    if (orderItem.ticketType.description === 'Klippkort') {
      ticketInfo += ` (Klippkort ${orderItem.originalQuantity}st)`;
    }
    else if (orderItem.ticketType.description === 'Enkelresa') {
      ticketInfo += ' (Enkel)';
    }
    else {
      ticketInfo += ` (${orderItem.ticketType.description})`;
    }

    return ticketInfo;
  }

}
